import type { IconProps } from '@src/components/icons/IconProps';

export function MenuIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M5 7h14M5 12h14M5 17h14" />
    </svg>
  );
}
